@import 'styles/mixins';
@import 'styles/variables';

.headers {
  display: grid;
  grid-template-columns: 1fr 1px 250px;
  @include sm-regular;
  color: var(--neutral-40);
  margin-bottom: 6px;
  margin-top: 12px;
  padding-left: 2px;

  @include for-phone-only {
    display: none;
  }
}
